export enum FilterBlockEnum {
  seller = 'seller',
  statistics = 'statistics',
  makesAndModels = 'makesAndModels',
  specification = 'specification',
  features = 'features',
}
